"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CountDown = void 0;
var _dateFns = require("date-fns");
var _react = require("react");
var _Text = _interopRequireDefault(require("../Text"));
var _jsxRuntime = require("react/jsx-runtime");
function dhm(ms) {
  let duration = (0, _dateFns.intervalToDuration)({
    start: 0,
    end: ms
  });
  return {
    ms,
    ...duration,
    pad: function (value) {
      return String(value || 0).padStart(2, "0");
    }
  };
}
const useTimeTill = function (deadline) {
  const [time, setTime] = (0, _react.useState)(dhm(new Date(deadline) - new Date()));
  const timer = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    timer.current = setInterval(function () {
      setTime(dhm(new Date(deadline) - new Date()));
    }, 1000);
    return function () {
      clearInterval(timer.current);
    };
  }, [setTime, deadline]);
  return time;
};
const CountDown = function (_ref) {
  let {
    deadline = "",
    debug = false,
    text = "{pad(days)} DAY{days === 1 ? '' : 'S'} {pad(hours)}:{pad(minutes)}:{pad(seconds)}",
    children = ""
  } = _ref;
  const time = useTimeTill(deadline);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [debug && /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
      style: {
        textAlign: "left"
      },
      children: JSON.stringify(time, undefined, 2)
    }), (time === null || time === void 0 ? void 0 : time.ms) < 1000 ? children : time && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      bindings: {
        ...time
      },
      children: text
    })]
  });
};
exports.CountDown = CountDown;
var _default = exports.default = CountDown;